import script from "./MGTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGTextField.vue?vue&type=script&setup=true&lang=ts"

import "./MGTextField.vue?vue&type=style&index=0&id=2b48c695&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b48c695"]])

export default __exports__